import React from "react";

import "./DescriptionOrbit.scss";
import Description from "../../molecules/description/description";
import "../../../styles/fontSizes.scss";
import "../../../styles/fontSizes.scss";
//Necesita que el padre tenga positicionamiento relativo.
//Este es un componente que emula una orbita mediante el uso de posicionamiento relativo y absoluto, haciendo uso
//del componenete Description para el contenido
const DescriptionOrbit = ({
  isOnCalendar,
  isOnFocus,
  textSize,
  rotation,
  bgColor,
  color,
  data,
  percentageSize,
}) => {
  return (
    <>
      <li
        style={{
          transform: `rotateZ(${rotation}Deg)`,
          height: percentageSize,
          width: percentageSize,
        }}
        className={`${
          isOnFocus ? "description-o__container--focus-2" : ""
        } description-o__container font-size--${textSize}`}
      >
        <Description
          isOnCalendar={isOnCalendar}
          isOnFocus={isOnFocus}
          bgColor={bgColor}
          color={color}
          rotation={-1 * rotation}
          className={`description-o__content ${
            isOnFocus
              ? "description-o__content--focus"
              : "description-o__content--normal"
          }`}
          data={data}
          textSize={textSize}
        />
      </li>
    </>
  );
};

export default DescriptionOrbit;
